__turbopack_context__.v({
  "alignEnd": "irlHya_alignEnd",
  "alignStart": "irlHya_alignStart",
  "button": "irlHya_button",
  "content": "irlHya_content",
  "dismissed": "irlHya_dismissed",
  "positionLeft": "irlHya_positionLeft",
  "positionRight": "irlHya_positionRight",
  "positionTop": "irlHya_positionTop",
  "text": "irlHya_text",
  "trigger": "irlHya_trigger",
});
